<script>
    export let geoJsonLoaded;

    const onReaderLoad = (fileName, event) => {
        
        try{
            var obj = JSON.parse(event.target.result);
            if(obj.type) geoJsonLoaded(fileName, obj);
        }catch(e){
            console.log(e);
        }
        
    }
    const readFile = (file) => {
        var reader = new FileReader()
        reader.onload = (event) => onReaderLoad(file.name, event)
        reader.readAsText(file)
    }
    const dropHandler = (ev) => {
        console.log('File(s) dropped', ev);

        if (ev.dataTransfer.items) {
            // Use DataTransferItemList interface to access the file(s)
            for (var i = 0; i < ev.dataTransfer.items.length; i++) {
            // If dropped items aren't files, reject them
                if (ev.dataTransfer.items[i].kind === 'file') {
                    var file = ev.dataTransfer.items[i].getAsFile();
                    readFile(file)
                    //console.log('... file[' + i + '].name = ' + file.name);
                }
            }
        } else {
            // Use DataTransfer interface to access the file(s)
            for (var i = 0; i < ev.dataTransfer.files.length; i++) {
                readFile(ev.dataTransfer.files[i])
                //console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
            }
        }

    }
    const dragOverHandler = (ev) => {
        console.log('drag Over');
    }
</script>

<div id="drop_zone" class="h100" on:drop|preventDefault={dropHandler} on:dragover|preventDefault={dragOverHandler}>
    <slot/>
</div>

<style>
    #drop_zone {
    }
</style>